export const APP_NAME_HEADER_KEY = 'ttc-app-name';
export const APP_VERSION_HEADER_KEY = 'ttc-app-version';
export const APP_VERSION = '4.166.0';
